module.exports = __webpack_public_path__ + "static/media/shield.f416daa7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/shield.svg
// module id = 271
// module chunks = 3